module.exports = "<!--The content below is only a placeholder and can be replaced.-->\n<!-- <span id=\"loader-spinner\" class=\"loading\"></span> -->\n<app-header></app-header>\n<app-menu></app-menu>\n<router-outlet></router-outlet>\n\n\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = ./src/app/app.component.html
// module chunks = main